import axios from 'axios'

// const server = 'http://32.1.4.234:11159/jss_zgh_grzx_server'

const server = 'https://tyzy.jsghfw.cn/jss_zgh_grzx_server'

export async function getSiteIdByDhSiteInfo(params) {
  return axios({
    url: `${server}/site/getSiteIdByDhSiteInfo`,
    method: 'get',
    params: params,
    withCredentials: true,
    timeout: 30000,
    headers: {
      'Content-Type': 'application/json',
    }
  });
}
